import React, { useEffect, useState } from "react";
import "./kicker.css";
import right from "../../assets/right.png";
import left from "../../assets/left.png";
import baby from "../../assets/babyst.png";
import num1 from "../../assets/num1.png";
import num2 from "../../assets/num2.png";
import num3 from "../../assets/num3.png";
import num4 from "../../assets/num4.png";
import num5 from "../../assets/num5.png";
import num6 from "../../assets/num6.png";
import num7 from "../../assets/num7.png";
import num8 from "../../assets/num8.png";
import num9 from "../../assets/num9.png";
import num10 from "../../assets/num10.png";
import kick from "../../assets/kickfoot.png";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function Kicker({ selectedTool, setSelectedTool }) {
  const [count, setCount] = useState(18);

  useEffect(() => {
    setSelectedTool("kick-timer");
  }, []);

  return (
    <div className="kicker-base">
      <Helmet>
        <title>Baby Kick Timer - Track Baby's Movements During Pregnancy</title>
        <meta
          name="description"
          content="Record kicks to ensure your baby’s well-being throughout your pregnancy. Stay informed and gain peace of mind by tracking your baby's activity patterns in real-time."
        />
        <meta
          name="keywords"
          content="Pregnancy kick counter, baby kick counter, Baby kick count"
        />
      </Helmet>
      <div style={{ backgroundColor: "white" }} className="main-kick">
        <div className="bread-container">
          <nav aria-label="breadcrumb">
            <ol className="crumb">
              <li className="breadcrumblist">
                <Link
                  to="/"
                  className="breadcrumb-link"
                  onClick={() => setSelectedTool("")}
                >
                  Home
                </Link>
              </li>
              <li className="breadcrumblist">
                <Link to="/tools" className="breadcrumb-link">
                  Tools
                </Link>
              </li>
              <li className="breadcrumblist active">Kick Timer</li>
            </ol>
          </nav>
        </div>
        <div className="baby-kick">
          <h1
            className="head1-kicker"
            style={{
              color: "#B24C76",
              textAlign: "center",
              textTransform: "initial",
              fontWeight: "bold",
            }}
          >
            Baby Kick Timer
          </h1>
          <div className="dynamic-kick">
            <div id="kick-img">
              <img src={baby} style={{ width: "120px" }} />
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  color: "#B24C76",
                }}
                id="your-week"
              >
                You are at week {count}
              </p>
            </div>
            <div style={{ width: "90%" }}>
              <p
                style={{
                  textAlign: "justify",
                  fontSize: "17px",
                  marginTop: "20px",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                Count Every Kick – A Sweet Connection with Your Baby!
              </p>
              <p
                style={{
                  textAlign: "justify",
                  fontSize: "17px",
                  marginTop: "0px",
                  color: "black",
                  lineHeight: "1.7",
                }}
              >
                Every little kick is a special reminder of the little one
                growing inside you. With each movement, excitement and joy fill
                your heart as you connect in a whole new way. It’s not just a
                flutter; it’s your baby’s way of saying, "I’m here!" and each
                nudge brings a smile to your face. Experience the love, the joy,
                and the bond growing stronger with every kick!
              </p>
            </div>
          </div>
          <div className="below-dyn">
            <p
              style={{
                textAlign: "justify",
                fontSize: "17px",
                color: "black",
                lineHeight: "1.7",
              }}
            >
              Babies kick to strengthen their muscles and practice movement.
              These kicks also allow them to stretch and get comfortable in
              their growing space. In addition to muscle building, babies may
              respond to external stimuli, such as sounds or light, and these
              movements help them develop coordination. Kicking is a normal and
              healthy part of pregnancy, signalling the baby’s growth and
              activity.
            </p>
          </div>

          <h3
            style={{
              textAlign: "center",
              marginTop: "40px",
              marginBottom: "20px",
            }}
          >
            Start Counting Kicks
          </h3>
          <div id="foot-cont">
            <Link to="counts">
              <div id="foot-bg">
                <img src={kick} />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Kicker;
